"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var SvgCalendarIcon = function SvgCalendarIcon(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return _react.default.createElement("svg", _extends({
    height: size,
    width: size,
    viewBox: "0 0 100 100"
  }, otherProps), _react.default.createElement("path", {
    style: {
      textIndent: 0,
      textTransform: "none",
      blockProgression: "tb"
    },
    d: "M30.031 5a2 2 0 00-2 2v12.25c-3.444.891-6 4.04-6 7.75 0 4.395 3.606 8 8 8 4.395 0 8-3.605 8-8 0-3.701-2.567-6.82-6-7.719V7a2 2 0 00-2-2zm40 0a2 2 0 00-2 2v12.25c-3.444.891-6 4.04-6 7.75 0 4.395 3.606 8 8 8 4.395 0 8-3.605 8-8 0-3.701-2.567-6.82-6-7.719V7a2 2 0 00-2-2zm-54 6C10.511 11 6 15.51 6 21.031V84.97C6 90.489 10.51 95 16.031 95H83.97C89.489 95 94 90.49 94 84.969V21.03C94 15.511 89.49 11 83.969 11H78c-1.057-.015-2.031.943-2.031 2s.974 2.015 2.031 2h5.969C87.339 15 90 17.66 90 21.031V39H10V21.031C10 17.661 12.66 15 16.031 15H22c1.057.015 2.031-.943 2.031-2s-.974-2.015-2.031-2h-5.969zM38 11a2 2 0 100 4h24a2 2 0 100-4H38zm-7.969 12c2.233 0 4 1.767 4 4s-1.767 4-4 4a3.97 3.97 0 01-4-4c0-2.233 1.767-4 4-4zm40 0c2.233 0 4 1.767 4 4s-1.767 4-4 4a3.97 3.97 0 01-4-4c0-2.233 1.767-4 4-4zM10 43h80v41.969C90 88.339 87.34 91 83.969 91H16.03C12.661 91 10 88.34 10 84.969V43z",
    overflow: "visible",
    fill: color
  }));
};

SvgCalendarIcon.propTypes = {
  color: _propTypes.default.string,
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
SvgCalendarIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = SvgCalendarIcon;
exports.default = _default;